import { getApi, postUpdateApi } from 'util/api';
import { omit } from 'ramda';

const PROPS_TO_OMIT = ['name', 'roles', 'updatedAt', 'userStatus'];
const ADMINUSERS_AUTH_BASE_URI = '/auth/adminusers';

export const load = (id) => getApi(`${ADMINUSERS_AUTH_BASE_URI}/${id}`);

export const update = ({ id, ...props }) =>
  postUpdateApi(ADMINUSERS_AUTH_BASE_URI, {
    id,
    ...omit(PROPS_TO_OMIT, props),
  });
